import { signOut } from "firebase/auth";
import React, { useEffect, useMemo, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../firebase.init";
import mbabaLogo from "../../Images/mbaba-logos.jpg";
import useParts from "../../hooks/useParts";
import { Link } from "react-router-dom";
import ActiveLink from "./ActiveLink";

const Navbar = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional: smooth scrolling animation
    });
  };
  const [user] = useAuthState(auth);

  const logout = () => {
    signOut(auth);
  };

  const [parts] = useParts([]);
  const products = useMemo(() => [...parts], [parts]);

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProducts, setFilteredProducts] = useState(products);

  useEffect(() => {
    console.log({ searchTerm });

    if (searchTerm) {
      setFilteredProducts(
        products.filter((product) =>
          product.name.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    } else {
      setFilteredProducts([]);
    }
  }, [searchTerm, products]);

  const menuItems = (
    <>
      <li>
        <ActiveLink to="/">Home</ActiveLink>
      </li>
      <li>
        <ActiveLink to="/shops">Shops</ActiveLink>
      </li>
      <li>
        <ActiveLink to="/dailyD">Daily Delights</ActiveLink>
      </li>
      <li>
        <ActiveLink to="/cService">Customer Service</ActiveLink>
      </li>
      <li>
        <ActiveLink to="/reviews">Reviews</ActiveLink>
      </li>

      <li>
        <ActiveLink to="/dashboard">Dashboard</ActiveLink>
      </li>

      <li>
        {user ? (
          <button className="btn btn-ghost" onClick={logout}>
            Sign Out
          </button>
        ) : (
          <ActiveLink className="text-green-500" to="/login">
            Login
          </ActiveLink>
        )}
      </li>
      <li></li>
    </>
  );

  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className="shadow-2xl py-0 p-0 sticky top-0 z-30"
      style={
        scrolled ? { backdropFilter: "blur(2px)" } : { background: "#076AE1" }
      }
    >
      <div className="navbar h-4  max-w-7xl mx-auto px-2">
        <div className="navbar-start pl-0">
          {/* ----------- nave bar for mobile----------- */}
          <div className="dropdown">
            <label
              tabIndex="0"
              onClick={toggleMenu}
              className="btn btn-ghost lg:hidden ml-0  shadow-2xl text-white bg-transparent "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 bg-transparent"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="3"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </label>
            <ul
              tabIndex="0"
              className={`menu menu-compact dropdown-content -ml-3 mt-2 p-2 w-screen bg-primary font-bold ${
                showMenu ? "block" : "hidden"
              }`}
            >
              <div className="px-5">{menuItems}</div>
            </ul>
          </div>

          <div className="w-24 max-w-xl mx-auto px-2">
            <Link
              style={{
                paddingInline: "0",
                backgroundColor: "transparent",
                border: "0",
              }}
              to="/"
              onClick={scrollToTop}
              className="btn btn-ghost normal-case text-xl mb-3 mx-auto "
            >
              <img
                className="border-2 border-white mt-1"
                style={{
                  width: "50px",
                  height: "50px",
                  padding: "0px",
                  borderRadius: "35px",
                }}
                src={mbabaLogo}
                alt="Logo"
              />
            </Link>
          </div>
        </div>

        {/* ------------ Nave bar for Mobile-----------  */}
        <div className="navbar-center ">
          <div className="navbar lg:navbar-center hidden lg:flex ">
            <ul className="menu menu-horizontal p-0">{menuItems}</ul>
          </div>
          <div className="form-control relative  max-w-xl w-32 mx-auto">
            <input
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
              type="text"
              placeholder="Search"
              className="input input-bordered bg-transparent text-accent border-2 border-white placeholder rounded-full"
            />
            {searchTerm && (
              <div
                className="scroll-smooth md:scroll-auto absolute top-12 right-0  overflow-scroll z-10 bg-slate-50 w-64 p-2 h-40 rounded"
                style={{ fontFamily: "Roboto" }}
              >
                <ul className="bg-transparent">
                  {filteredProducts.slice(0, 40).map((product) => (
                    <li
                      key={product._id}
                      className="border-b-2 p-0 hover:bg-primary hover:text-white"
                    >
                      <Link to={`/product/${product._id}`}>
                        {product.name.slice(0, 22)}..
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div className="navbar-end">
          {/* ------------Nave bar for mobile----------- */}

          <Link to="/dashboard">
            <label
              tabIndex="1"
              htmlFor="dashboard-sidebar2"
              className="btn btn-ghost lg:hidden ml-0 shadow-2xl text-white bg-transparent"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="3"
                  d="M20 18H4M20 12H12M20 6H4"
                />
              </svg>
            </label>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
